export const getFileExtension = (filename: string) => {
  // Check if there is a dot in the filename and it's not the first character
  const lastIndex = filename.lastIndexOf(".");
  if (lastIndex > 0) {
    // Ensure the dot is not at the beginning
    return filename.substring(lastIndex + 1).toLowerCase();
  }
  return null; // Return an empty string if no extension is found
};
